export class ListGroupItem {
  leftText: string;
  centerText?: string;
  rightText?: string;
  detailsAction?: any;
}

export class ListDropdownGroupItem {
  header: string;
  toggled: boolean = false;
  dropdownItems?: ListGroupItem[];
  body?: string;
}
